/** Questions still owed an answer, in the order they should be worked. */
export function outstanding(questions) {
    const rank = {
        needs_human: 0,
        open: 1,
        answered: 2,
        resolved: 3,
        dismissed: 4,
    };
    return questions
        .filter((q) => q.status === "open" || q.status === "needs_human" || q.status === "answered")
        .sort((a, b) => rank[a.status] - rank[b.status] || a.createdAt.localeCompare(b.createdAt));
}
//# sourceMappingURL=thread.js.map